export interface TestPersonnalityModel {
    baseline: string;
    code_test: string;
    nom_profil: string;
    type_personnalite: string;
}

export const testPersonalities: TestPersonnalityModel[] = [
{
    baseline: 'Penseurs imaginatifs et stratèges, avec un plan pour tout.',
    code_test: 'INTJ-A / INTJ-T',
    nom_profil: 'Architecte',
    type_personnalite: 'Analystes',
},
{
    baseline:'Inventeurs innovateurs démontrant une soif inextinguible de connaissances.',
    code_test: 'INTP-A / INTP-T',
    nom_profil: 'Logicien',
    type_personnalite: 'Analystes',
},
{
    baseline:'Leaders hardis, imaginatifs et dotés d’un fort caractère, qui trouvent toujours un moyen d’arriver à leurs fins, ou le créent.',
    code_test: 'ENTJ-A / ENTJ-T',
    nom_profil: 'Commandant',
    type_personnalite: 'Analystes',
},
{
    baseline:'Penseurs astucieux et curieux incapables de résister à un défi intellectuel.',
    code_test: 'ENTP-A / ENTP-T',
    nom_profil: 'Innovateur',
    type_personnalite: 'Analystes',
},
{
    baseline:'Idéalistes calmes et mystiques et pourtant très inspirants et infatigables.',
    code_test: 'INFJ-A / INFJ-T',
    nom_profil: 'Avocat',
    type_personnalite: 'Diplomates',
},
{
    baseline:'Personnes poétiques, gentilles et altruistes qui sont toujours prêtes à soutenir une bonne cause.',
    code_test: 'INFP-A / INFP-T',
    nom_profil: 'Médiateur',
    type_personnalite: 'Diplomates',
},
{
    baseline:'Leaders charismatiques et inspirants, capables de fasciner leur public.',
    code_test: 'ENFJ-A / ENFJ-T',
    nom_profil: 'Protagoniste',
    type_personnalite: 'Diplomates',
},
{
    baseline:'Esprits libres enthousiastes, créatifs et sociables, qui arrivent toujours à trouver une raison de sourire.',
    code_test: 'ENFP-A / ENFP-T',
    nom_profil: 'Inspirateur',
    type_personnalite: 'Diplomates',
},
{
    baseline:'Individus pragmatiques et intéressés par les faits, dont le sérieux ne saurait être mis en cause.',
    code_test: 'ISTJ-A / ISTJ-T',
    nom_profil: 'Logisticien',
    type_personnalite: 'Sentinelles',
},
{
    baseline:'Protecteurs très dévoués et très chaleureux, toujours prêts à défendre ceux qu’ils aiment.',
    code_test: 'ISFJ-A / ISFJ-T',
    nom_profil: 'Défenseur',
    type_personnalite: 'Sentinelles',
},
{
    baseline:'Excellents gestionnaires, d’une efficacité inégalée quand il s’agit de gérer les choses, ou les gens.',
    code_test: 'ESTJ-A / ESTJ-T',
    nom_profil: 'Directeur',
    type_personnalite: 'Sentinelles',
},
{
    baseline:'Personnes extraordinairement attentionnées, sociables et populaires, toujours prêtes à aider les autres.',
    code_test: 'ESFJ-A / ESFJ-T',
    nom_profil: 'Consul',
    type_personnalite: 'Sentinelles',
},
{
    baseline:'Expérimentateurs hardis et pragmatiques, maîtres de toutes sortes d’outils.',
    code_test: 'ISTP-A / ISTP-T',
    nom_profil: 'Virtuose',
    type_personnalite: 'Explorateurs',
},
{
    baseline:'Artistes flexibles et charmants, toujours prêts à explorer et à essayer quelque chose de nouveau.',
    code_test: 'ISFP-A / ISFP-T',
    nom_profil: 'Aventurier',
    type_personnalite: 'Explorateurs',
},
{
    baseline:'Personnes astucieuses, énergiques et très perspicaces, qui aiment vraiment vivre à la pointe du progrès.',
    code_test: 'ESTP-A / ESTP-T',
    nom_profil: 'Entrepreneur',
    type_personnalite: 'Explorateurs',
},
{
    baseline:'Amuseurs spontanés, énergiques et enthousiastes ; avec eux, on ne s’ennuie jamais.',
    code_test: 'ESFP-A / ESFP-T',
    nom_profil: 'Amuseur',
    type_personnalite: 'Explorateurs',
},
{
    baseline: 'Penseurs imaginatifs et stratèges, avec un plan pour tout.',
    code_test: 'INTJ',
    nom_profil: 'Architecte',
    type_personnalite: 'Analystes',
},
{
    baseline:'Inventeurs innovateurs démontrant une soif inextinguible de connaissances.',
    code_test: 'INTP',
    nom_profil: 'Logicien',
    type_personnalite: 'Analystes',
},
{
    baseline:'Leaders hardis, imaginatifs et dotés d’un fort caractère, qui trouvent toujours un moyen d’arriver à leurs fins, ou le créent.',
    code_test: 'ENTJ',
    nom_profil: 'Commandant',
    type_personnalite: 'Analystes',
},
{
    baseline:'Penseurs astucieux et curieux incapables de résister à un défi intellectuel.',
    code_test: 'ENTP',
    nom_profil: 'Innovateur',
    type_personnalite: 'Analystes',
},
{
    baseline:'Idéalistes calmes et mystiques et pourtant très inspirants et infatigables.',
    code_test: 'INFJ',
    nom_profil: 'Avocat',
    type_personnalite: 'Diplomates',
},
{
    baseline:'Personnes poétiques, gentilles et altruistes qui sont toujours prêtes à soutenir une bonne cause.',
    code_test: 'INFP',
    nom_profil: 'Médiateur',
    type_personnalite: 'Diplomates',
},
{
    baseline:'Leaders charismatiques et inspirants, capables de fasciner leur public.',
    code_test: 'ENFJ',
    nom_profil: 'Protagoniste',
    type_personnalite: 'Diplomates',
},
{
    baseline:'Esprits libres enthousiastes, créatifs et sociables, qui arrivent toujours à trouver une raison de sourire.',
    code_test: 'ENFP',
    nom_profil: 'Inspirateur',
    type_personnalite: 'Diplomates',
},
{
    baseline:'Individus pragmatiques et intéressés par les faits, dont le sérieux ne saurait être mis en cause.',
    code_test: 'ISTJ',
    nom_profil: 'Logisticien',
    type_personnalite: 'Sentinelles',
},
{
    baseline:'Protecteurs très dévoués et très chaleureux, toujours prêts à défendre ceux qu’ils aiment.',
    code_test: 'ISFJ',
    nom_profil: 'Défenseur',
    type_personnalite: 'Sentinelles',
},
{
    baseline:'Excellents gestionnaires, d’une efficacité inégalée quand il s’agit de gérer les choses, ou les gens.',
    code_test: 'ESTJ',
    nom_profil: 'Directeur',
    type_personnalite: 'Sentinelles',
},
{
    baseline:'Personnes extraordinairement attentionnées, sociables et populaires, toujours prêtes à aider les autres.',
    code_test: 'ESFJ',
    nom_profil: 'Consul',
    type_personnalite: 'Sentinelles',
},
{
    baseline:'Expérimentateurs hardis et pragmatiques, maîtres de toutes sortes d’outils.',
    code_test: 'ISTP',
    nom_profil: 'Virtuose',
    type_personnalite: 'Explorateurs',
},
{
    baseline:'Artistes flexibles et charmants, toujours prêts à explorer et à essayer quelque chose de nouveau.',
    code_test: 'ISFP',
    nom_profil: 'Aventurier',
    type_personnalite: 'Explorateurs',
},
{
    baseline:'Personnes astucieuses, énergiques et très perspicaces, qui aiment vraiment vivre à la pointe du progrès.',
    code_test: 'ESTP',
    nom_profil: 'Entrepreneur',
    type_personnalite: 'Explorateurs',
},
{
    baseline:'Amuseurs spontanés, énergiques et enthousiastes ; avec eux, on ne s’ennuie jamais.',
    code_test: 'ESFP',
    nom_profil: 'Amuseur',
    type_personnalite: 'Explorateurs',
},
];
